export default __webpack_public_path__ + "static/media/qrCode.29373fce.png";